export default __webpack_public_path__ + "static/media/loc_img_1.3d465387.jpg";